import { useEffect, useState } from 'react';
import { Orientation } from 'expo-screen-orientation/src/ScreenOrientation.types';
import * as ScreenOrientation from 'expo-screen-orientation';

export function useScreenOrientation() {
  const [orientation, setOrientation] = useState<Orientation>(Orientation.UNKNOWN);

  useEffect(() => {
    ScreenOrientation.getOrientationAsync().then((d) => setOrientation(d));
    const subscription = ScreenOrientation.addOrientationChangeListener((d) => {
      setOrientation(d.orientationInfo.orientation);
    });
    return () => {
      ScreenOrientation.removeOrientationChangeListener(subscription);
    };
  }, []);

  return orientation;
}
